module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-02.dfffa55d.png";